export const TRADES = [
  'Electrical', 'Plumbing', 'Sprinkler', 'HVAC', 'Framing', 'Concrete',
  'Demolition', 'Roofing', 'Doors', 'Drywall', 'Millwork', 'Flooring',
  'Ceramic', 'Epoxy', 'Painting', 'Accessories'
];

export const PROFESSIONS = [
  'Architect',
  'Structural Engineer',
  'Mechanical Engineer',
  'Electrical Engineer',
  'Civil Engineer',
  'Surveyor',
  'Designer',
  'Consultant',
  'Other'
];
